export default "__VITE_ASSET__CqtHjKJu__"